module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtSeven.6928fb0.png";